<template>
    <div>
        <vendorHeader />
        <div class="m-2 pa-2">
            <tabs-comp :tabs="tabs" />
            <v-row>
              <v-col cols="12" md="12" sm="12" class="text-end">
                <b-button
                    v-b-toggle.add_vendor_request
                    class="btn-sm btn "
                    style="margin-top:11px;width:150px;background:transparent;border:none"
                    id="multiply-button" 
                  >
                  <div style="width:150px;" :class="`multiply-button-content-`+lang.lalgin">اضافة ارسالية</div>
                  
                  </b-button>
              </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-simple-table striped hover style="width:100%;">
                        <thead>
                            <tr>
                                <th class="text-center">تاريخ الارسالية</th>
                                <th class="text-center">المنتجات المرسلة</th>
                                <th class="text-center">اجمالي المرسل</th>
                                <th class="text-center">المنتجات المستلمة</th>
                                <th class="text-center">اجمالي المستلم</th>
                                <th class="text-center">الحالة</th>
                                <th class="text-center">{{lang.action}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in myrequests" :key="index">
                                <td class="text-center">{{String(item.reqdate).substr(0,10)}}</td>
                                <td class="text-center">{{item.qtty}}</td>
                                <td class="text-center">{{item.total}}</td>
                                <td class="text-center">{{item.rqtty}}</td>
                                <td class="text-center">{{item.rtotal}}</td>
                                <td class="text-center" v-html="getStatus(item.status)"></td>
                                <td style="margin-left: 5px;width:60px;background:black;border-bottom:2px solid #fff !important;">
                                  <v-btn style="width:50px;font-size:0.2em;background:black;box-shadow:none;color:#fff;height:25px !important;" v-b-toggle.view_vendor_request @click="ViewItem(item)">{{lang.view}} &nbsp;	&nbsp;	<i :class="`fas fa-caret-`+lang.lalgin"></i></v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>
        <Footer />
        <addVendorRequest />
        <showVendorRequest ref="showVendorRequest" />
    </div>
</template>

<script>
import vendorHeader from '@/components/vendor-header.vue'
import Footer from '@/components/Footer.vue'
import TabsComp from '@/components/tabsComp.vue'
import addVendorRequest from '@/components/addVendorReqeuest.vue'
import showVendorRequest from '@/components/showVendorRequest.vue'
import axios from 'axios'
export default({
    components: {vendorHeader,Footer,TabsComp,addVendorRequest,showVendorRequest},
    data() {
        return {
            myrequests:[
              
            ]
        }
    },
    created() {
      this.getRequests();
    },
    methods: {
      ViewItem(item){
        // console.log(item);
        this.$refs.showVendorRequest.ginfo = item;
        this.$refs.showVendorRequest.reqid = item.id;
        this.$refs.showVendorRequest.grows = item.rows;
        this.$refs.showVendorRequest.checkData();
      },
      getStatus(s){
        if(s == 1) return "تحت المراجعة"
        if(s == 2) return "تم الاستلام"
        if(s == 3) return "ملغي"
        if(s == 4) return "استلام جزئي"
      },
      getRequests(){
        const post = new FormData();
        post.append('type', 'getVendorRequest');
        post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
        post.append("data[a]","all");
        axios.post(
          this.$store.state.SAMCOTEC.r_path, post
        ).then((response) => {
          this.myrequests = response.data.results.data;
        })
      },
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
                }else{
                return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        }, 
        tabs: function(){
            return [
                {
                    index:0,name:this.lang.sales,href:'/vendors/vendor-index/',class:'mytab3',
                },
                {
                    index:2,name:this.lang.payment_requests,href:'/vendors/payment-requests/',class:'mytab3',
                },
                {
                    index:3,name:this.lang.requests,href:'/vendors/requests/',class:'mytab',
                },
                {
                    index:3,name:this.lang.products,href:'/vendors/products/',class:'mytab3',
                },
            ]
        }
    }
})
</script>
<style>
.v-data-table-header__icon{
  display:none !important;
}
.outsearch{
  color:green;
  border:1px solid #ccc;
}
thead th, tfoot th, .tfoot th{
  background: #c3d9ff !important;
  color:#000 !important;
  border:1px solid #000 !important;
  font-size:12px;
  white-space: nowrap;
}
thead th a , thead th i, thead th i a{
  color:#FFF !important;
  white-space: nowrap;
}
tbody td{
  font-size:12px;
  color:#000 !important;
  white-space: nowrap;
  border:1px solid #000;
}
.v-breadcrumbs{
  padding:12px !important;
}
.v-tab--active{
  background:#ccc;
  color:#FFF;
}
.v-tabs-slider-wrapper a{
  color:#FFF !important;
}
tfoot th{
  border:1px solid #000;
}
.close svg {
    width: 74px !important;
    height: 34px !important;
    color: #FFF;
    background: red;
}
header button.close {
    width: 24px !important;
    height: 24px !important;
}
input{
  box-shadow: none !important;
}
button:active,button:focus{
  box-shadow: none !important;
}
._mybtn{
  font-size:.8rem;
  border:0px solid #fff;
  width:100%;
}
._mybtn2{
  font-size:.8rem;
  background:rgb(15, 212, 230) !important;
  border:0px solid #000;
  width:100%;
}
._mybtn4{
  font-size:.8rem;
  background:rgb(15, 90, 230) !important;
  border:0px solid #fff;
}
._mybtn3{
  font-size:.8rem;
  background:#198754 !important;
  border:0px solid #fff;
}
._mybtn1{
  font-size:.8rem;
  background:#fe7b33 !important;
  border:0px solid #fff;
}
td,th{
      height: 30px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th{
  padding: 0 10px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    padding: 0 10px !important;
}
</style>